import { createFileRoute } from "@tanstack/react-router";
import { strategyEditorSearchSchema } from "~/features/strategy-editor/strategy-editor-route";

export const Route = createFileRoute("/_app/build_/$blueprintId")({
  validateSearch: strategyEditorSearchSchema,
});
